module.exports = __webpack_public_path__ + "img/gb9123_24_d.prt.7e5ac0e8.jpg";